export default __webpack_public_path__ + "static/kevinLoveMobile-fa3a667539aa1f8593272963968dc6eb.png";